import * as bookingActions from '../actions/booking.action';
import { Booking } from '../../booking/models/booking';
import * as moment from 'moment';

export interface State {
  bookings: any[];
  numberOfBookings: number;
  currentBooking: Booking;
  selectedBookingToView: any;
  overallTotalPrice: number;
  overallNgynFees: number;
  availableRooms: any[];
  meals: { [id: string]: number };
  loading: boolean;
  loaded: boolean;
  error: any;
  ngynFee: number;
  sowetoTourPrice: number;
  unionBuildingTourPrice: number;
  sunCityTourPrice: number;
  goldReefCityTourPrice: number;
}

const initialState: State = {
  bookings: [],
  numberOfBookings: 0,
  currentBooking: {
    title: '',
    firstNames: '',
    lastName: '',
    email: '',
    gender: '',
    country: '',
    idNumber: '',
    mobilePhone: '',
    nameOfChurch: '',
    groupASession: '',
    groupBSession: '',
    includeInBusiness: false,
    expertise: '',
    arrivalDate: '',
    departureDate: '',
    meal1: '',
    meal2: '',
    meal3: '',
    otherInfo: '',
    packageChoice: '',
    hotelChoice1: '',
    hotelChoice2: '',
    hotelChoice3: '',
    includeSowetoTour: false,
    includeUnionBuildingTour: false,
    includeSunCityTour: false,
    includeGoldReefCityTour: false,
    tours: [],
    bookingPrice: 0,
    includeNgyn: false,
    ngynFee: 0
  },
  selectedBookingToView: null,
  overallTotalPrice: 0,
  overallNgynFees: 0,
  availableRooms: [
    {
      id: 'five-star-single',
      name: 'Five Star (Single)',
      price: 510,
      minPrice: 471,
      hotels: [
        'African Rock Hotels, Kempton Park',
        "Peermont D'Oreale Grande hotel, Kempton Park",
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'five-star-sharing',
      name: 'Five Star (Sharing)',
      price: 335,
      minPrice: 320,
      hotels: [
        'African Rock Hotels, Kempton Park',
        "Peermont D'Oreale Grande hotel, Kempton Park",
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'four-star-single',
      name: 'Four Star (Single)',
      price: 220,
      minPrice: 195,
      hotels: [
        'Southern Sun OR Tambo, Kempton Park',
        'Premier Hotel Rhodesfield Kempton Park',
        'Holiday Inn, Boksburg',
        'African Moon, Gen Marais Kempton Park',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'four-star-sharing',
      name: 'Four Star (Sharing)',
      price: 177,
      minPrice: 147,
      hotels: [
        'Southern Sun OR Tambo, Kempton Park',
        'Premier Hotel Rhodesfield Kempton Park',
        'Holiday Inn, Boksburg',
        'African Moon, Gen Marais Kempton Park',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'three-star-single',
      name: 'Three Star (Single)',
      price: 190,
      minPrice: 167,
      hotels: [
        'Aviator Hotel, Kempton Park',
        'Garden Court OR Tambo, Isando',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'three-star-sharing',
      name: 'Three Star (Sharing)',
      price: 136,
      minPrice: 116,
      hotels: [
        'Aviator Hotel, Kempton Park',
        'Garden Court OR Tambo, Isando',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'two-star-single',
      name: 'Two Star (Single)',
      price: 157,
      minPrice: 150,
      hotels: [
        'Garden Court, Eastgate',
        'Easystay, Eastgate',
        'Sun 1 Benoni',
        'Sun 1, OR Tambo',
        'Sun 1, Edenvale',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'two-star-sharing',
      name: 'Two Star (Sharing)',
      price: 105,
      minPrice: 95,
      hotels: [
        'Garden Court, Eastgate',
        'Easystay, Eastgate',
        'Sun 1 Benoni',
        'Sun 1, OR Tambo',
        'Sun 1, Edenvale',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    },
    {
      id: 'one-star-sharing',
      name: 'One Star (Sharing)',
      price: 90,
      minPrice: 80,
      hotels: [
        'Road Lodge, Isando',
        'Road Lodge, Lakeside Germiston',
        'All Danquah Guest Lodge, Kempton Park',
        'Timosha Guest Lodge, Kempton Park',
        'Other'
      ],
      imageUrls: [],
      amenities: []
    }
  ],
  meals: {
    'African Dish': 7,
    'Nandos - The grande meal: chicken burger, 4 nuggets': 7,
    'Nandos - Double chicken burger': 6,
    'Nandos - 1/2 chicken': 7,
    'Nandos - full chicken': 12,
    'Nandos - Salads': 5,
    'Nandos - Chicken platter': 40,
    'KFC - Fully loaded box meal': 7,
    'KFC - Summer lunch': 7,
    'KFC - Crunch burger combo': 3,
    'KFC - Chicken Lunch box': 5,
    'KFC - Salads': 4,
    'KFC - Family treat': 16,
    'KFC - 21 Pieces bucket': 23,
    'McDonalds - Big Mac': 5,
    'McDonalds - Double 1/4 pound with cheese': 4,
    'McDonalds - Chicken foldover': 4,
    'McDonalds - Crispy chicken salad': 4,
    'McDonalds - Nuggets': 2,
    'Debonnairs - Pizza/chicken & Mushroom': 9,
    'Debonnairs - Pizza Meat': 10,
    'Debonnairs - Somthing Meaty': 10,
    'Debonnairs - Triple Decker': 13,
    'Debonnairs - Cram decker': 14,
    'Debonnairs - Double Stack': 11,
    'Debonnairs - Vegetarian': 8
  },
  loading: false,
  loaded: false,
  error: null,
  ngynFee: 0, // Was 5.5 previously and changed it by request from Pastor Maseko
  sowetoTourPrice: 50,
  unionBuildingTourPrice: 40,
  sunCityTourPrice: 75,
  goldReefCityTourPrice: 65
};

export function reducer(
  state = initialState,
  action: bookingActions.bookingActions
) {
  switch (action.type) {
    case bookingActions.INCLUDE_NGYN_CONFERENCE: {
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeNgyn: true
        }
      };
    }
    case bookingActions.EXCLUDE_NGYN_CONFERENCE: {
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeNgyn: false
        }
      };
    }
    case bookingActions.INCLUDE_SOWETO_TOUR: {
      const tourPrice = state.sowetoTourPrice;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeSowetoTour: true,
          tours: [...state.currentBooking.tours, 'soweto'],
          bookingPrice: state.currentBooking.bookingPrice + tourPrice
        }
      };
    }
    case bookingActions.EXCLUDE_SOWETO_TOUR: {
      const tourPrice = state.sowetoTourPrice;
      const tours = state.currentBooking.tours.filter(t => t !== 'soweto');
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeSowetoTour: false,
          bookingPrice: state.currentBooking.bookingPrice - tourPrice,
          tours
        }
      };
    }
    case bookingActions.INCLUDE_SUN_CITY_TOUR: {
      const tourPrice = state.sunCityTourPrice;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeSunCityTour: true,
          tours: [...state.currentBooking.tours, 'sun city'],
          bookingPrice: state.currentBooking.bookingPrice + tourPrice
        }
      };
    }
    case bookingActions.EXCLUDE_SUN_CITY_TOUR: {
      const tourPrice = state.sunCityTourPrice;
      const tours = state.currentBooking.tours.filter(t => t !== 'sun city');
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeSunCityTour: false,
          bookingPrice: state.currentBooking.bookingPrice - tourPrice,
          tours
        }
      };
    }
    case bookingActions.INCLUDE_UNION_BUILDING_TOUR: {
      const tourPrice = state.unionBuildingTourPrice;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeUnionBuildingTour: true,
          tours: [...state.currentBooking.tours, 'union building'],
          bookingPrice: state.currentBooking.bookingPrice + tourPrice
        }
      };
    }
    case bookingActions.EXCLUDE_UNION_BUILDING_TOUR: {
      const tourPrice = state.unionBuildingTourPrice;
      const tours = state.currentBooking.tours.filter(
        t => t !== 'union building'
      );
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeUnionBuildingTour: false,
          bookingPrice: state.currentBooking.bookingPrice - tourPrice,
          tours
        }
      };
    }
    case bookingActions.INCLUDE_GOLD_REEF_CITY_TOUR: {
      const tourPrice = state.goldReefCityTourPrice;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeGoldReefCityTour: true,
          tours: [...state.currentBooking.tours, 'gold reef city'],
          bookingPrice: state.currentBooking.bookingPrice + tourPrice
        }
      };
    }
    case bookingActions.EXCLUDE_GOLD_REEF_CITY_TOUR: {
      const tourPrice = state.goldReefCityTourPrice;
      const tours = state.currentBooking.tours.filter(
        t => t !== 'gold reef city'
      );
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          includeGoldReefCityTour: false,
          bookingPrice: state.currentBooking.bookingPrice - tourPrice,
          tours
        }
      };
    }
    case bookingActions.GET_BOOKINGS: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case bookingActions.RESET_CURRENT_BOOKING: {
      const currentBooking = {
        title: '',
        firstNames: '',
        lastName: '',
        email: '',
        gender: '',
        country: '',
        idNumber: '',
        mobilePhone: '',
        nameOfChurch: '',
        groupASession: '',
        groupBSession: '',
        includeInBusiness: 'Yes',
        expertise: '',
        arrivalDate: '',
        departureDate: '',
        meal1: '',
        meal2: '',
        meal3: '',
        otherInfo: '',
        packageChoice: '',
        hotelChoice1: '',
        hotelChoice2: '',
        hotelChoice3: '',
        includeSowetoTour: false,
        includeUnionBuildingTour: false,
        includeSunCityTour: false,
        includeGoldReefCityTour: false,
        tours: [],
        bookingPrice: 0,
        includeNgyn: false,
        ngynFee: 0
      };
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          ...currentBooking
        }
      };
    }
    case bookingActions.GET_BOOKINGS_SUCCESS: {
      const bookings: any[] = action.payload;
      const numberOfBookings = bookings.length;
      const overallTotalPrice = bookings.reduce((acc: number, booking: any) => {
        return acc + booking.bookingPrice;
      }, 0);
      const overallNgynFees = bookings.reduce(
        (acc: number, booking: Booking) => {
          if (booking.ngynFee) {
            return acc + booking.ngynFee;
          } else {
            return acc;
          }
        },
        0
      );
      const currentBooking = {
        title: '',
        firstNames: '',
        lastName: '',
        email: '',
        gender: '',
        country: '',
        idNumber: '',
        mobilePhone: '',
        nameOfChurch: '',
        groupASession: '',
        groupBSession: '',
        includeInBusiness: 'Yes',
        expertise: '',
        arrivalDate: '',
        departureDate: '',
        meal1: '',
        meal2: '',
        meal3: '',
        otherInfo: '',
        packageChoice: '',
        hotelChoice1: '',
        hotelChoice2: '',
        hotelChoice3: '',
        includeSowetoTour: false,
        includeUnionBuildingTour: false,
        includeSunCityTour: false,
        includeGoldReefCityTour: false,
        tours: [],
        bookingPrice: 0,
        ngynFee: 0
      };
      return {
        ...state,
        bookings,
        numberOfBookings,
        overallTotalPrice,
        overallNgynFees,
        loading: false,
        loaded: true
      };
    }
    case bookingActions.VIEW_BOOKING_DETAIL: {
      const selectedBookingToView = action.payload;
      return {
        ...state,
        selectedBookingToView
      };
    }
    // case bookingActions.GO_TO_ADD_BOOKING_VIEW: {
    //   const currentBooking = {
    //     title: '',
    //     firstNames: '',
    //     lastName: '',
    //     email: '',
    //     gender: '',
    //     country: '',
    //     idNumber: '',
    //     mobilePhone: '',
    //     nameOfChurch: '',
    //     trackSessions: [],
    //     includeInBusiness: 'Yes',
    //     expertise: '',
    //     arrivalDate: '',
    //     departureDate: '',
    //     meal1: '',
    //     meal2: '',
    //     meal3: '',
    //     otherInfo: '',
    //     packageChoice: '',
    //     hotelChoice1: '',
    //     hotelChoice2: '',
    //     hotelChoice3: '',
    //     includeSowetoTour: false,
    //     includeUnionBuildingTour: false,
    //     includeSunCityTour: false,
    //     includeGoldReefCityTour: false,
    //     tours: [],
    //     bookingPrice: 0
    //   };
    //   return {
    //     ...state,
    //     currentBooking: {
    //       ...state.currentBooking,
    //       ...currentBooking
    //     }
    //   };
    // }
    // case bookingActions.GET_CURRENT_BOOKING_FAIL:
    // case bookingActions.EDIT_BOOKING_FAIL:
    // case bookingActions.GET_BOOKINGS_FAIL:
    // case bookingActions.ADD_BOOKING_FAIL: {
    //   const error = action.payload;
    //   return {
    //     ...state,
    //     error,
    //     loading: false,
    //     loaded: false
    //   };
    // }
    // case bookingActions.GET_CURRENT_BOOKING_SUCCESS: {
    //   const currentBooking = action.payload;
    //   const room = state.availableRooms.find(
    //     r => r.name === currentBooking.selectedRoom
    //   );
    //   const tours = [];
    //   if (currentBooking.includeSowetoTour) {
    //     tours.push('soweto');
    //   }
    //   if (currentBooking.includeUnionBuildingTour) {
    //     tours.push('union building');
    //   }
    //   if (currentBooking.includeSunCityTour) {
    //     tours.push('sun city');
    //   }
    //   if (currentBooking.includeGoldReefCityTour) {
    //     tours.push('gold reef city');
    //   }

    //   return {
    //     ...state,
    //     currentBooking
    //   };
    // }
    //
    case bookingActions.ADD_PERSONAL_INFO: {
      const personalInfo = action.payload;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          ...personalInfo
        }
      };
    }
    case bookingActions.ADD_CONFERENCE_INFO: {
      const conferenceInfo = action.payload;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          ...conferenceInfo
        }
      };
    }
    case bookingActions.ADD_ACCOMMODATION_INFO: {
      const accommodationInfo = action.payload;

      const meal1: string = accommodationInfo.meal1;
      const meal2: string = accommodationInfo.meal2;
      const meal3: string = accommodationInfo.meal3;

      const meal1Price: number = state.meals[meal1] ? state.meals[meal1] : 0;
      const meal2Price: number = state.meals[meal2] ? state.meals[meal2] : 0;
      const meal3Price: number = state.meals[meal3] ? state.meals[meal3] : 0;

      const bookingPrice = meal1Price + meal2Price + meal3Price;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          ...accommodationInfo,
          bookingPrice
        }
      };
    }
    case bookingActions.ADD_ROOM_INFO: {
      const roomInfo = action.payload;
      const arrivalDate = moment(state.currentBooking.arrivalDate);
      const departureDate = moment(state.currentBooking.departureDate);
      let numberOfDays = moment
        .duration(departureDate.diff(arrivalDate))
        .days();
      // if (state.currentBooking.packageChoice) {
      //   const existingPackagePrice = state.availableRooms.find(
      //     r => r.name === state.currentBooking.packageChoice
      //   ).price;

      //   const newRoom = state.availableRooms.find(
      //     r => r.name === roomInfo.packageChoice
      //   );

      //   const newRoomPrice = newRoom ? newRoom.price : 0;
      //   numberOfDays = numberOfDays ? numberOfDays : 0;

      //   const oldTotalRoomPrice = numberOfDays * existingPackagePrice;
      //   const initialBookingPrice =
      //     state.currentBooking.bookingPrice - oldTotalRoomPrice;

      //   const newTotalRoomPrice = newRoomPrice * numberOfDays;
      //   return {
      //     ...state,
      //     currentBooking: {
      //       ...state.currentBooking,
      //       ...roomInfo,
      //       bookingPrice: initialBookingPrice + newTotalRoomPrice
      //     }
      //   };
      // } else {
      //   const room = state.availableRooms.find(
      //     r => r.name === roomInfo.packageChoice
      //   );
      //   const roomPrice = room ? room.price : 0;
      //   numberOfDays = numberOfDays ? numberOfDays : 0;
      //   const totalRoomPrice = roomPrice * numberOfDays;
      //   return {
      //     ...state,
      //     currentBooking: {
      //       ...state.currentBooking,
      //       ...roomInfo,
      //       bookingPrice: state.currentBooking.bookingPrice + totalRoomPrice
      //     }
      //   };
      // }
      const room = state.availableRooms.find(
        r => r.name === roomInfo.packageChoice
      );
      const roomPrice = room ? room.price : 0;
      numberOfDays = numberOfDays ? numberOfDays : 0;
      const totalRoomPrice = roomPrice * numberOfDays;
      return {
        ...state,
        currentBooking: {
          ...state.currentBooking,
          ...roomInfo,
          bookingPrice: state.currentBooking.bookingPrice + totalRoomPrice
        }
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/booking.reducer.ts